export default "__VITE_ASSET__oMjUmxw1__"